import { render, staticRenderFns } from "./account-button.vue?vue&type=template&id=588c0560"
import script from "./account-button.vue?vue&type=script&lang=ts"
export * from "./account-button.vue?vue&type=script&lang=ts"
import style0 from "./account-button.vue?vue&type=style&index=0&id=588c0560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports